<template>
    <div class="container-fluid bannerPadWrapper" ref="cmp">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "MainMobileBanner",
        created() {
            let vm = this
            this.$nextTick(function () {
                $(this.$refs.cmp).find('.bannerPad-carousel').owlCarousel({
                    loop:true,
                    margin:10,
                    nav:false,
                    autoplay:false,
                    dots:true,
                    responsive:{
                        0:{
                            items:1
                        },
                        768:{
                            items:1
                        },
                        1000:{
                            items:1
                        }
                    }
                })
            })
        },

    }
</script>

<style scoped>

</style>